import React from 'react';
import { Spinner } from 'reactstrap';

const Loading = ({ size, color }) => (
  <div className="text-center mt-4">
    <Spinner style={{ width: size || '6rem', height: size || '6rem' }} color={ color || 'secondary' } />
  </div>
);

export default Loading;
